/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import useStyles from "./styles";
import clsx from "clsx";

import { Grid, Button, TextField } from "@material-ui/core";
import { connect } from "react-redux";
import { Images } from "config/images";
import { Controller, useForm } from "react-hook-form";
import { registerAction } from "store/actions/LoginPageAction";
import { useHistory } from "react-router-dom";
import { isEmpty } from "lodash";

const RegisterPage = props => {
	const { handlerRegister } = props;
	const classes = useStyles();
	const history = useHistory();

	const {
		handleSubmit,
		control,
		formState: { errors }
	} = useForm();

	const TOKEN = localStorage.getItem("token");

	if (!!TOKEN) {
		history.push("/home");
	}

	const onSubmit = data => {
		const onSuccess = () => {
			history.push("/create_password");
		};
		const dataRegister = {
			data: data,
			onSuccess
		};
		handlerRegister(dataRegister);
	};

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.rootForm }}>
				<Grid
					classes={{ root: classes.btnBack }}
					onClick={() => {
						history.goBack();
					}}
				>
					<img src={Images.icArrowLeftBlack} alt="icArrowLeftBlack" />
				</Grid>
				<Grid classes={{ root: classes.headerRegister }}>
					<img src={Images.logoRegister} alt="logoRegister" />
					<Grid>
						<Grid classes={{ root: classes.titleHeader }}>
							Đăng ký tài khoản
						</Grid>
						<Grid classes={{ root: classes.subTitleHeader }}>
							Vui lòng nhập thông tin để đăng ký
						</Grid>
					</Grid>
				</Grid>
				<form onSubmit={handleSubmit(onSubmit)}>
					<Grid
						classes={{
							root: clsx(classes.title, classes.borderTitle)
						}}
					>
						<img src={Images.icBgUser} alt="icBgUser" /> Thông tin
						chủ cửa hàng <span> (*)</span>
					</Grid>
					<Grid classes={{ root: classes.title }}>Họ và tên</Grid>
					<Controller
						control={control}
						name="owner"
						rules={{
							required: "Vui lòng nhập họ và tên"
						}}
						render={({ field }) => (
							<TextField
								{...field}
								className={clsx(
									classes.customInput,
									errors?.owner ? classes.inputError : ""
								)}
							/>
						)}
					/>

					<Grid classes={{ root: classes.title }}>Số điện thoại</Grid>
					<Controller
						control={control}
						name="phone"
						rules={{
							required: "Vui lòng nhập số điện thoại",
							pattern: /(84|0[3|5|7|8|9])+([0-9]{8})\b/g
						}}
						render={({ field }) => (
							<React.Fragment>
								<TextField
									{...field}
									className={clsx(
										classes.customInput,
										errors?.phone ? classes.inputError : ""
									)}
								/>
								{errors.phone && (
									<Grid classes={{ root: classes.textError }}>
										{errors.phone.type === "pattern" &&
											"Vui lòng nhập đúng định dạng số điện thoại"}
									</Grid>
								)}
							</React.Fragment>
						)}
					/>

					<Grid classes={{ root: classes.title }}>Tên của hàng</Grid>
					<Controller
						control={control}
						name="name"
						rules={{
							required: "Vui lòng nhập tên của hàng"
						}}
						render={({ field }) => (
							<TextField
								{...field}
								className={clsx(
									classes.customInput,
									errors?.name ? classes.inputError : ""
								)}
							/>
						)}
					/>

					<Grid classes={{ root: classes.title }}>Địa chỉ</Grid>
					<Controller
						control={control}
						name="address"
						rules={{
							required: "Vui lòng nhập tên của hàng"
						}}
						render={({ field }) => (
							<TextField
								{...field}
								className={clsx(
									classes.customInput,
									errors?.address ? classes.inputError : ""
								)}
							/>
						)}
					/>

					<Grid classes={{ root: classes.title }}>Số CMND/CCCD</Grid>
					<Controller
						control={control}
						name="identifyCardNumber"
						rules={{
							required: "Vui lòng nhập số CMND/CCCD"
						}}
						render={({ field }) => (
							<TextField
								{...field}
								className={clsx(
									classes.customInput,
									errors?.identifyCardNumber
										? classes.inputError
										: ""
								)}
							/>
						)}
					/>

					<Grid
						classes={{
							root: clsx(classes.title, classes.borderTitle)
						}}
					>
						<img src={Images.icExportOrder} alt="icExportOrder" />{" "}
						Thông tin xuất hóa đơn
					</Grid>

					<Grid classes={{ root: classes.title }}>Mã số thuế</Grid>
					<Controller
						control={control}
						name="taxCode"
						render={({ field }) => (
							<TextField
								{...field}
								className={clsx(classes.customInput)}
							/>
						)}
					/>
					{!isEmpty(errors) && (
						<Grid
							style={{ textAlign: "center" }}
							classes={{ root: classes.textError }}
						>
							Vui lòng điền đầy đủ thông tin đăng ký
						</Grid>
					)}
					<Grid classes={{ root: classes.bodyBtnSubmit }}>
						<Button
							type="submit"
							classes={{ root: classes.btnSubmit }}
						>
							Đăng ký
						</Button>
					</Grid>
				</form>
			</Grid>
		</Grid>
	);
};

const mapStateToProps = state => {
	return {};
};

const mapDispatchToProps = dispatch => {
	return {
		handlerRegister: data => {
			dispatch(registerAction(data));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterPage);
